import React from "react";
import dynamic from "next/dynamic";
import classnames from "classnames";

import Cover from "../Cover";
import DesktopSearchCard, { DesktopSearchCardProps } from "../DesktopSearchCard";
import { CitySearchResultWithCateg } from "@vahak/core/dist/custom-types/location-search";
import { InputChangeEventHandler } from "@vahak/core/dist/custom-types/handler";

export interface DesktopProps {
    isSearchCardMinimized: boolean;
    searchBy?: DesktopSearchCardProps["searchBy"];
    onChangeSearchBy: DesktopSearchCardProps["onChangeSearchBy"];
    src: CitySearchResultWithCateg | undefined;
    onSelectSrc: (city: CitySearchResultWithCateg | undefined) => void;
    dest: CitySearchResultWithCateg | undefined;
    onSelectDest: (city: CitySearchResultWithCateg | undefined) => void;
    selectedDestQuickFilter: DesktopSearchCardProps["selectedDestQuickFilter"];
    nameSearchVal: string;
    onInputNameSearch: InputChangeEventHandler;
    onClearName?: () => void;
    className?: string;
    topContainerClassName?: string;
    coverClassName?: string;
    searchCardClassName?: string;
    srcParam?: string;
}

const Desktop = ({
    isSearchCardMinimized,
    searchBy,
    onChangeSearchBy,
    src,
    onSelectSrc,
    dest,
    onSelectDest,
    selectedDestQuickFilter,
    nameSearchVal,
    onInputNameSearch,
    onClearName,
    className,
    topContainerClassName,
    coverClassName,
    searchCardClassName,
    srcParam
}: DesktopProps) => {
    return (
        <div className={classnames(className)}>
            <div className={classnames(topContainerClassName)}>
                <Cover className={classnames(coverClassName)} style={{ height: "220px" }} cityName={srcParam} />
                <div className={classnames("container", searchCardClassName)}>
                    <DesktopSearchCard
                        isSearchCardMinimized={isSearchCardMinimized}
                        src={src}
                        onSelectSrc={onSelectSrc}
                        dest={dest}
                        onSelectDest={onSelectDest}
                        selectedDestQuickFilter={selectedDestQuickFilter}
                        nameSearchVal={nameSearchVal}
                        onInputNameSearch={onInputNameSearch}
                        searchBy={searchBy}
                        onChangeSearchBy={onChangeSearchBy}
                        onClearName={onClearName}
                    />
                </div>
            </div>
        </div>
    );
};

export default Desktop;
